import { initializeCarousel } from "./components/glideInit";

(function () {
    $('.js-mbb-carousel').each(function () {
        const $carousel = $(this);
        const autoPlay = $carousel.attr('data-autoplay') === '0' || $carousel.attr('data-autoplay') === 'false' ? false : parseInt($carousel.attr('data-autoplay'), 10)
        
        const defaults = {
            type: 'carousel',
            gap: 0,
            autoplay: autoPlay,
            animationDuration: 1000
        };

        initializeCarousel($carousel , defaults, true);
    });

    $(document).on('click', '.glide__arrow--right', function () {
        var $nextButton = $(this);
        setTimeout(function () {
            var $activeSlide = $nextButton.closest('.glide__container').siblings('.glide__track');
            $activeSlide.find('.glide__slide--active .mbb-hero__cta-button-list a').first().focus();
        }, 1100);
    });
})();